import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const UpdateSchool = async (FormData, SchoolID) => {
  try {
    const SchoolDocument = await doc(db, "Schools", SchoolID);

    const data = {
      ...FormData,
      ...HelperForMetaData({}),
    };

    delete data.createdAt;
    delete data.createdBy;

    await updateDoc(SchoolDocument, data);

    return true;
  } catch (error) {
    console.log(error);

    return false;
  }
};

export default UpdateSchool;
